import {
  ArrowDownIcon,
  CpuIcon,
  SparklesIcon,
  FileTextIcon,
  VideoIcon,
  MicIcon,
  ImageIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Modality {
  label: string
  icon: LucideIcon
  iconClass: string
  glowClass: string
  positionClass: string
}

export const modalities: Modality[] = [
  { label: 'TEXT', icon: FileTextIcon, iconClass: 'text-apple-blue', glowClass: 'modality-glow-blue', positionClass: 'md:top-0 md:left-12' },
  { label: 'VIDEO', icon: VideoIcon, iconClass: 'text-purple-600', glowClass: 'modality-glow-purple', positionClass: 'md:top-0 md:right-12' },
  { label: 'AUDIO', icon: MicIcon, iconClass: 'text-amber-600', glowClass: 'modality-glow-amber', positionClass: 'md:bottom-0 md:left-12' },
  { label: 'OBRAZ', icon: ImageIcon, iconClass: 'text-emerald-600', glowClass: 'modality-glow-emerald', positionClass: 'md:bottom-0 md:right-12' },
]

export interface EngineStep {
  num: string
  title: string
  desc: string
  icon: LucideIcon
}

export const engineSteps: EngineStep[] = [
  { num: '01', title: 'Vstup', desc: 'Pošlete text, obrázok, video alebo zvuk. Alebo všetko naraz.', icon: ArrowDownIcon },
  { num: '02', title: 'Spracovanie', desc: 'AI vytvorí jednotný vektor — odtlačok významu, nie slov.', icon: CpuIcon },
  { num: '03', title: 'Výstup', desc: 'Odpoveď, ktorá rozumie kontextu naprieč všetkými formátmi.', icon: SparklesIcon },
]

export const engineMetrics = [
  { label: 'Rozpoznanie textu', value: 99 },
  { label: 'Analýza obrazu', value: 97 },
  { label: 'Porozumenie videu', value: 94 },
  { label: 'Spracovanie zvuku', value: 92 },
  { label: 'Krížové vyhľadávanie', value: 96 },
]
